let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7RECz")).then(() => parcelRequire('h08YX'));